import { render, staticRenderFns } from "./IntegracionODDO.vue?vue&type=template&id=0a14c17a&scoped=true"
import script from "./IntegracionODDO.vue?vue&type=script&lang=js"
export * from "./IntegracionODDO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a14c17a",
  null
  
)

export default component.exports